import { FC } from "react";
import Spinner from "../Spinner";
import { StyledLoading } from "./styled";

type Props = {
  text?: string;
};

const Loading: FC<Props> = ({ text }) => (
  <StyledLoading>
    <Spinner />
    {!!text && (
      <h3>{text}</h3>
    )}
  </StyledLoading>
);

export default Loading;
